import React from 'react'

import { Dropdown, Menu, Table } from 'antd'

import OrderedPageFilter from 'core/application/commons/orderedPageFilter'
import { PagedInternalUsers } from 'core/application/csiDashboard/internalUsers/getInternalUsers'

import Icon from 'common/components/general/Icon'

import { parseZoneFormat } from 'common/dateFormatters'

import './InternalUsers.less'

interface InternalUsersTableProps {
  setSearchFilter: (value: OrderedPageFilter) => void
  searchFilter: OrderedPageFilter
  internalUsers: PagedInternalUsers
  loadingInternalUsers: boolean
  history: any
  translate: (key: string) => string
  onEdit: (id: string) => void
  onReinvite: (id: string, fullName: string) => void
  onDeactivate: (id: string, fullName: string) => void
}

const InternalUsersTable: React.FC<InternalUsersTableProps> = ({
  setSearchFilter,
  searchFilter,
  internalUsers,
  loadingInternalUsers,
  history,
  translate,
  onEdit,
  onReinvite,
  onDeactivate,
}) => {
  const getColumns = (filter: OrderedPageFilter) => {
    const columns = [
      {
        title: translate('general.fullname'),
        dataIndex: 'fullname',
        key: 'fullname',
        render: (text: string, record: any) => {
          return (
            <span>
              <p>{record.fullname}</p>
            </span>
          )
        },
      },
      {
        title: translate('general.email'),
        dataIndex: 'email',
        key: 'email',
        sorter: true,
        render: (text: string, record: any) => (
          <span>
            <p>{record.email}</p>
          </span>
        ),
      },
      {
        title: translate('general.roles'),
        dataIndex: 'roles',
        key: 'roles',
        render: (text: string, record: any) => (
          <span>
            <p>{record.apps.join(', ')}</p>
          </span>
        ),
      },
      {
        title: translate('general.created-at'),
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (text: string, record: any) => (
          <span>
            <p>{parseZoneFormat(record.createdAt)}</p>
          </span>
        ),
      },
      {
        title: translate('general.actions'),
        dataIndex: '',
        key: '',
        render: (text: string, record: any) => (
          <span>
            <div className="actions">
              <Dropdown
                overlay={menu(
                  translate,
                  () => onEdit(record.id),
                  () => onReinvite(record.id, record.fullname),
                  () => onDeactivate(record.id, record.fullname),
                )}
                placement="bottomCenter"
              >
                <div className="internal_users_actions">
                  <Icon type="far fa-ellipsis-h" fontAwesome />
                </div>
              </Dropdown>
            </div>
          </span>
        ),
      },
    ]
    const columnToSort: any = columns.find((c) => c.key === filter.orderColumn)
    columnToSort.defaultSortOrder = filter.orderDescending ? 'descend' : 'ascend'

    return columns
  }

  const onExpensesTableChange = (pagination: any, filters: any, sorter: any) => {
    setSearchFilter({
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: sorter.field || 'createdAt',
      orderDescending: sorter.order !== 'ascend',
    })
  }

  return (
    <Table
      dataSource={internalUsers.items}
      onChange={onExpensesTableChange}
      loading={loadingInternalUsers}
      columns={getColumns(searchFilter)}
      pagination={{
        total: internalUsers.totalItemCount,
        pageSize: internalUsers.pageSize,
        current: internalUsers.pageNumber,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40'],
      }}
    />
  )
}

const menu = (
  translate: (key: string) => string,
  onEdit: () => void,
  onReinvite: () => void,
  onDeactivate: () => void,
) => (
  <Menu>
    <Menu.Item onClick={onEdit}>
      <div>
        <Icon type="far fa-pencil" fontAwesome className="mr-8" />
        <span>Set permissions</span>
      </div>
    </Menu.Item>
    {/*<Menu.Item onClick={onReinvite}>*/}
    {/*  <div>*/}
    {/*    <Icon type="far fa-paper-plane" fontAwesome className="mr-8" />*/}
    {/*    <span>{translate('general.resend-invite')}</span>*/}
    {/*  </div>*/}
    {/*</Menu.Item>*/}
    {/*<Menu.Item onClick={onDeactivate}>*/}
    {/*  <div>*/}
    {/*    <Icon type="far fa-times-circle" fontAwesome className="mr-8" />*/}
    {/*    <span>{translate('general.deactivate')}</span>*/}
    {/*  </div>*/}
    {/*</Menu.Item>*/}
  </Menu>
)

export default InternalUsersTable
